import React from 'react';

function Toggle({ items, ...otherProps }) {
    const {
        firstItem,
        secondItem,
        firstItemID,
        secondItemID,
        activeList
    } = items;

    return (
        <div className="flex rounded-md p-1 bg-[#EAEAEA] w-fit select-none font-mulish">
            <button 
                id={firstItemID} 
                {...otherProps} 
                className={`text-[16px] leading-5 outline-none border-none rounded p-[10px] gap-[10px] 
                ${activeList === firstItemID ? 
                'bg-[#111827] font-bold text-[#FFFFFF]' : 
                'font-semibold text-[#666666]'}
                `}
            >
                {firstItem}
            </button>

            <button 
                id={secondItemID} 
                {...otherProps} 
                className={`text-[16px] leading-[20px] outline-none border-none rounded p-[10px] gap-[10px] 
                ${activeList === secondItemID ? 
                'bg-[#111827] font-bold text-[#FFFFFF]' : 
                'font-semibold text-[#666666]'}
                `}
            >
                {secondItem}
            </button>
        </div>
    )
}

export default Toggle;
